import React, { useEffect, useState } from 'react';
import Header from '../../dashboard/header';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom'; 
import { FaTools, FaTags } from 'react-icons/fa';
import useAuth from '../../dashboard/useAuth';
import axios from 'axios';

const Ajouter_tag = ({titre}) => {
    useAuth()
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('user_id');

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
      if (user_id) {
        document.title = "eTrainApp | Ajouter Tag"; // Définit le titre de la page
      }
    }, [user_id]);

    const navigate = useNavigate();  // Hook pour la redirection

    const handleSubmit = async (event) => {
        event.preventDefault();
        
        // Récupération des données du formulaire
        const formData = {
            titre: event.target.titre.value,
            description: event.target.description.value,
            // statut: event.target.statut.value,
        };
    
        try {
            const response = await fetch(process.env.REACT_APP_HOTE+`/ajouter-tag/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
    
            if (!response.ok) {
                const errorData = await response.json();
                console.error('Erreur:', errorData);
            } else {
                const data = await response.json();
                console.log('Succès:', data);
                navigate(`/Liste-tag`);  // Redirection après succès
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const handleCancel = () => {
        window.location.reload(); // Recharge la page après l'annulation
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');
  
    const verifGroupe = async () => {
      const groupeStored = localStorage.getItem('groupe');
      const accesGroupeStored = localStorage.getItem('accesGroupe');
  
      if (groupeStored && accesGroupeStored) {
        setGroupeId(groupeStored);
        setAccesGroupe(JSON.parse(accesGroupeStored));
      } else {
        try {
          const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
          if (response.status === 200) {
            const data = response.data;
            setGroupeId(data.groupe);
  
            let cleanedAccessArray = [];
            if (Array.isArray(data.acces)) {
              cleanedAccessArray = data.acces.map((item) =>
                item.acces
                  ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                  : []
              ).flat();
  
              setAccesGroupe(cleanedAccessArray);
            }
  
            localStorage.setItem('groupe', data.groupe);
            localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
          }
        } catch (error) {
          // console.error('Erreur lors de la vérification du groupe', error);
        }
      }
    };
  
    useEffect(() => {
      if (user_id) {
        verifGroupe();
      }
    }, [user_id]);
  
    if (!accesGroupe.includes("QCM")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    
    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><FaTags size={25} className='mr-2'/>Ajout de tag </h2>
                            <small>Administration des Tags.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-tag`}>Tags</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        Ajout de tag
                                    </li>
                                </ol>
                            </small>
                        </div>
                </div>
                <div className="col-6 mx-auto m-4 p-5">
                    <div className="ibox-content">
                        <div className="hpanel">
                            <div className="panel-body">
                                <form className="m-t" role="form" onSubmit={handleSubmit} encType="multipart/form-data">
                                    <div className="">
                                        <div className="form-group">
                                            <label>Titre du tag <strong style={{color: 'red'}}>*</strong></label>
                                            <input type="text" className="form-control" placeholder="" required name="titre" />
                                        </div>
                                        <div className="form-group">
                                            <label>Description</label>
                                            <input type="text" className="form-control" placeholder="" name="description" />
                                        </div>
                                        {/* <div className="form-group">
                                            <label>Statut <strong style={{color: 'red'}}>*</strong></label>
                                            <select
                                                className="form-control"
                                                name="statut"
                                                // value={tagData.statut}
                                                // onChange={(e) => setFormData({ ...formData, statut: e.target.value })}
                                            >
                                                <option value="inactif">Inactif</option>
                                                <option value="actif">Actif</option>
                                            </select>
                                        </div> */}
                                    </div>
                                    <div className="text-center mt-5">
                                        <button type="button" className="btn btn-default mr-2" onClick={handleCancel}>Annuler</button>
                                        <button type="submit" className="btn btn-success">Enregistrer</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    ); 
}

export default Ajouter_tag;
